/* 2026-10-18 · Don's mystery gift, cart step (Claude). README: exports/gift-cart-2026-10-18/README.md
   Rules
   1. A DON- code is on the cart (cart.discount_codes, or the discount_code cookie from a /discount/CODE link,
      which is then put on the cart once) and the cart without the gift is at or above
      EUR 76 x Shopify.currency.rate x 1.01  ->  exactly 1 gift line (first gift variant that can be added).
   2. No DON- code, or below the minimum  ->  no gift line.
   3. The gift line shows "Don's mystery gift" + "Free", no link, no quantity, no options; DON- texts are hidden.
   Test switch (never on the live theme): ?gift_test=1 acts as if a DON- code is on the cart, ?gift_test=0 stops it.
   Optional on preview only: &gift_variant=<id> uses that variant as the gift (stand-in while the gift product is a Draft). */
(function () {
  var C = window.DrippyGift;
  if (!C || window.__drippyGift) return;
  window.__drippyGift = true;
  // Liquid's t filter escapes HTML (Don&#39;s): turn the strings back into plain text
  Object.keys(C.t || {}).forEach(function (k) { var x = document.createElement('textarea'); x.innerHTML = C.t[k]; C.t[k] = x.value; });

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var live = !!(window.Shopify && Shopify.theme && Shopify.theme.role === 'main');
  var TK = 'drippy:gift-test', VK = 'drippy:gift-variant', CK = 'drippy:gift-cookie-used';
  var ss = { get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
             set: function (k, v) { try { v == null ? sessionStorage.removeItem(k) : sessionStorage.setItem(k, v); } catch (e) {} } };

  if (!live) {
    var q = location.search;
    if (/[?&]gift_test=1/.test(q)) ss.set(TK, '1');
    if (/[?&]gift_test=0/.test(q)) { ss.set(TK, null); ss.set(VK, null); }
    var mv = q.match(/[?&]gift_variant=(\d+)/);
    if (mv) ss.set(VK, mv[1]);
  } else { ss.set(TK, null); ss.set(VK, null); }

  var testOn = function () { return !live && ss.get(TK) === '1'; };
  var variants = function () {
    var v = (!live && ss.get(VK)) ? [ss.get(VK)] : (C.variants || []);
    return v.filter(Boolean).map(Number);
  };
  var known = function () {
    var k = (C.known || []).concat(variants()).filter(Boolean).map(Number);
    return k;
  };
  var isGift = function (item) {
    return known().indexOf(Number(item.variant_id)) !== -1 || (item.properties && item.properties._drippy_gift);
  };
  var isDon = function (code) { return typeof code === 'string' && code.toUpperCase().indexOf(C.prefix) === 0; };

  function cookieCode() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    if (!m) return null;
    var c = decodeURIComponent(m[1]);
    return isDon(c) ? c : null;
  }

  var J = { 'Content-Type': 'application/json', Accept: 'application/json' };
  // our own requests go straight to the original fetch, so they are never mistaken for the shopper's
  function req(path, body) {
    var p = body ? origFetch(root + path, { method: 'POST', headers: J, body: JSON.stringify(body) })
                 : origFetch(root + path, { headers: { Accept: 'application/json' } });
    return p.then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); });
  }

  /* ---------- the drawer / cart page refresh (same as the theme, without opening the drawer) ---------- */
  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  function paint(sections, count) {
    if (!sections) return;
    var parse = function (html, sel) { var d = new DOMParser().parseFromString(html, 'text/html'); return d.querySelector(sel); };
    try {
      if (sections['cart-drawer']) {
        var cur = document.querySelector('#CartDrawer'), nu = parse(sections['cart-drawer'], '#CartDrawer');
        if (cur && nu) {
          var box = cur.querySelector('[data-cv2-added]'), keep = box && !box.hidden ? box.innerHTML : null;
          var scroll = cur.querySelector('.drawer__contents'), top = scroll ? scroll.scrollTop : 0;
          cur.innerHTML = nu.innerHTML;
          if (keep) { var b2 = cur.querySelector('[data-cv2-added]'); if (b2) { b2.innerHTML = keep; b2.hidden = false; } }
          var s2 = cur.querySelector('.drawer__contents'); if (s2) s2.scrollTop = top;
          var inner = cur.querySelector('.drawer__inner'), cd = document.querySelector('cart-drawer');
          if (cd && typeof count === 'number') cd.classList.toggle('is-empty', count === 0);
          var ov = cur.querySelector('#CartDrawer-Overlay');
          if (ov && cd && cd.close) ov.addEventListener('click', cd.close.bind(cd));
        }
      }
      if (sections['cart-icon-bubble']) {
        var bub = document.getElementById('cart-icon-bubble'), nb = parse(sections['cart-icon-bubble'], '.shopify-section');
        if (bub && nb) bub.innerHTML = nb.innerHTML;
      }
    } catch (e) {}
  }
  function refreshCartPage() {
    if (!/\/cart\/?$/.test(location.pathname)) return;
    // the cart page renders server side; one quiet reload shows the new lines
    var last = +(ss.get('drippy:gift-reload') || 0);
    if (Date.now() - last < 4000) return;   // never a reload loop
    ss.set('drippy:gift-reload', String(Date.now()));
    location.reload();
  }

  /* ---------- the rule ---------- */
  var busy = false, again = false;
  function run() {
    if (busy) { again = true; return; }
    busy = true;
    req('cart.js').then(function (r) {
      var cart = r.j || {};
      var items = cart.items || [];
      var gifts = items.filter(isGift);
      if (gifts[0] && gifts[0].original_price != null) window.DrippyGift.value = gifts[0].original_price;
      var rest = items.filter(function (i) { return !isGift(i); });
      var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
      var hasDon = codes.some(isDon);
      var cc = cookieCode();

      // a /discount/DON-XXXX link: put the code on the cart once (keeps the codes already there)
      if (!hasDon && cc && ss.get(CK) !== cc.toUpperCase()) {
        ss.set(CK, cc.toUpperCase());
        var list = (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
        list.push(cc);
        return req('cart/update.js', { discount: list.join(','), sections: SECTIONS, sections_url: location.pathname })
          .then(function (u) { paint(u.j && u.j.sections, u.j && u.j.item_count); again = true; });
      }

      var rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1;
      var need = Math.ceil(C.min * 100 * rate * (1 + C.margin));
      var total = rest.reduce(function (s, i) { return s + (i.final_line_price != null ? i.final_line_price : i.line_price); }, 0);
      // strict (default): a DON- code Shopify still calls not applicable once the gift is in the bag AND the cart is above the minimum is a dead
      // code (typo, used, expired, wrong shopper). Take the gift out and do not try that code again this visit.
      var dons = (cart.discount_codes || []).filter(function (d) { return isDon(d.code); });
      var RK = 'drippy:gift-refused';
      var refused = (ss.get(RK) || '').split(',');
      if (C.strict && !testOn() && gifts.length && dons.length && total >= need && !dons.some(function (d) { return d.applicable; })) {
        ss.set(RK, refused.concat(dons.map(function (d) { return d.code.toUpperCase(); })).join(','));
        refused = (ss.get(RK) || '').split(',');
      }
      var usable = dons.filter(function (d) { return refused.indexOf(d.code.toUpperCase()) === -1; });
      var want = ((usable.length > 0) || testOn()) && rest.length > 0 && total >= need;
      window.DrippyGift.last = { want: want, refused: refused.filter(Boolean), total: total, need: need, rate: rate, codes: codes, test: testOn(), gifts: gifts.length };

      if (want && gifts.length === 1 && gifts[0].quantity === 1) return;   // already right
      if (!want && gifts.length === 0) return;                              // already right

      if (!want || gifts.length > 1 || (gifts[0] && gifts[0].quantity !== 1)) {
        // remove every gift line (or trim to one), then add back if still wanted
        var upd = {};
        gifts.forEach(function (g, n) { upd[g.key] = (want && n === 0) ? 1 : 0; });
        return req('cart/update.js', { updates: upd, sections: SECTIONS, sections_url: location.pathname })
          .then(function (u) { paint(u.j && u.j.sections, u.j && u.j.item_count); refreshCartPage(); });
      }

      // want and no gift yet: add the first gift variant that can be added in this market
      var vs = variants(), n = 0;
      if (!vs.length) return;
      var tryAdd = function () {
        if (n >= vs.length) return;
        var id = vs[n++];
        return req('cart/add.js', { items: [{ id: id, quantity: 1, properties: { _drippy_gift: '1' } }], sections: SECTIONS, sections_url: location.pathname })
          .then(function (a) {
            if (!a.ok) return tryAdd();   // sold out in this market: next one
            paint(a.j && a.j.sections);
            again = true;                 // check once more: does Shopify accept the code now the gift is in?
            refreshCartPage();
          });
      };
      return tryAdd();
    }).catch(function () {}).finally(function () {
      busy = false;
      decorate();
      if (again) { again = false; setTimeout(run, 50); }
    });
  }

  /* ---------- the look of the gift line + hiding DON- texts ---------- */
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    // the shop's own money format first (euro markets: "€79" in every language), like every other price on the site
    if (cur === 'EUR' && typeof window.formatMoney === 'function' && window.theme && theme.moneyFormat) {
      try { var t = document.createElement('div'); t.innerHTML = window.formatMoney(cents, theme.moneyFormat); var o = t.textContent.trim(); if (o) return o; } catch (e) {}
    }
    var lang = (document.documentElement.lang || 'en').replace('_', '-');
    var whole = cents % 100 === 0;
    try { return new Intl.NumberFormat(lang, { style: 'currency', currency: cur, minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 }).format(cents / 100).replace(/^([^\d\s]+)\s+(?=\d)/, '$1'); }
    catch (e) { return (cents / 100).toFixed(whole ? 0 : 2) + ' ' + cur; }
  }
  function decorate() {
    var ids = known().map(String);
    [].slice.call(document.querySelectorAll('.cart-item[data-variant-id]')).forEach(function (row) {
      if (ids.indexOf(row.getAttribute('data-variant-id')) === -1) return;
      if (!row.classList.contains('dg-gift')) row.classList.add('dg-gift');
      var name = row.querySelector('.cart-item__name');
      if (name && name.getAttribute('data-dg') !== '1') {
        name.textContent = C.t.name;
        name.setAttribute('data-dg', '1');
        name.removeAttribute('href'); name.setAttribute('aria-disabled', 'true'); name.setAttribute('tabindex', '-1');
        // 21 Oct (Jo): no second line under the gift name
      }
      [].slice.call(row.querySelectorAll('a[href]')).forEach(function (a) { a.removeAttribute('href'); a.setAttribute('tabindex', '-1'); });
      [].slice.call(row.querySelectorAll('img')).forEach(function (im) { if (im.alt !== C.t.name) im.alt = C.t.name; });
      var pw = row.querySelector('.cart-item__price-wrapper');
      if (pw && !pw.querySelector('.dg-free')) {
        var f = document.createElement('div'); f.className = 'dg-free cart-item__final-price';
        var fr = document.createElement('span'); fr.className = 'dg-free-txt'; fr.textContent = C.t.free;
        f.appendChild(fr);
        pw.appendChild(f);
      }
      // the gift's worth, struck through before "Free" (its own price, so it follows the nightly gift swap)
      var fw = pw && pw.querySelector('.dg-free');
      var val = window.DrippyGift && window.DrippyGift.value;
      if (fw && val > 0) {
        var txt = money(val);
        var was = fw.querySelector('.dg-was');
        if (!was) { was = document.createElement('s'); was.className = 'dg-was'; fw.insertBefore(was, fw.firstChild); }
        if (was.textContent !== txt) was.textContent = txt;
      }
    });
    // the cv2 "Added:" line shows the gift's own product title right after the add: use the gift name
    var add = document.querySelector('[data-cv2-added-name]');
    if (add && /mystery gift/i.test(add.textContent) && add.textContent !== C.t.name) add.textContent = C.t.name;
    // DON- codes: per-line discount tags are hidden, the savings row is named after the gift
    var scope = [].slice.call(document.querySelectorAll('cart-drawer, #main-cart-items, #main-cart-footer, .cart__footer, form#cart'));
    scope.forEach(function (el) {
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), node, hits = [];
      while ((node = w.nextNode())) { if (/\bDON-[A-Z0-9]+/i.test(node.nodeValue)) hits.push(node); }
      hits.forEach(function (t) {
        var li = t.parentNode && t.parentNode.closest && t.parentNode.closest('.discounts__discount, .cart-discount-code__pill');
        if (li) { li.style.display = 'none'; return; }
        t.nodeValue = t.nodeValue.replace(/\bDON-[A-Z0-9]+/ig, C.t.name);
      });
    });
  }

  /* ---------- watch the theme's own cart requests ---------- */
  var origFetch = window.fetch.bind(window);
  var timer = null;
  var later = function () { clearTimeout(timer); timer = setTimeout(run, 120); };
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch(input, init);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { later(); }).catch(function () {});
    }
    return p;
  };
  var XO = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (/\/cart\/(add|change|update|clear)/.test(String(url))) this.addEventListener('loadend', later);
    return XO.apply(this, arguments);
  };

  var pend = false;
  new MutationObserver(function () {
    if (pend) return; pend = true;
    Promise.resolve().then(function () { pend = false; decorate(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  // the gift line is not a link and has no picker, even for keyboard users
  document.addEventListener('click', function (e) {
    var row = e.target.closest && e.target.closest('.cart-item.dg-gift');
    if (row && e.target.closest('a, quantity-input, cart-remove-button')) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { decorate(); run(); });
  else { decorate(); run(); }
  window.addEventListener('pageshow', function (e) { if (e.persisted) run(); });
  window.DrippyGift.run = run;
})();
